import styled from "styled-components"

const EventWrapper = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  color: ${(props) => props.theme.a_color_gradients.a_light};
`

const AllEventsButton = styled.div`
  & > a {
    &::before {
      background: ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }
`

export { EventWrapper, AllEventsButton }
